/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import FooterStepButton from "../components/FooterStepButton";
import Container from "../components/Container";
import usePluginUtils from "../hooks/usePluginUtils";
import NavigationHeader from "../components/NavigationHeader";
import ServicesList from "../components/booking/service/ServicesList";
import BookingStepList from "../components/booking/steps/BookingStepList";
import { useBooking } from "../hooks/useBooking";

const Services = () => {
  const { selectedServices } = useBooking();
  const { isPluginEnabled } = usePluginUtils();

  return (
    <Container>
      <NavigationHeader location back="step" />
      <BookingStepList title="Select service">
        <ServicesList categorized={isPluginEnabled("event_category")} />
      </BookingStepList>
      {!!selectedServices.length && <FooterStepButton services={selectedServices} />}
    </Container>
  );
};

export default Services;
